import ProductSearchCss from "../../pages/product-search-page/product-search.module.css";
import { Trans } from "@coworker/locales";

export const ClearSearchHistory = ({ onClick }: { onClick: () => void }) => {
  return (
    <button className={ProductSearchCss["clear-history"]} onClick={onClick}>
      <Trans>clearHistoryString</Trans>
    </button>
  );
};
